import swal from "sweetalert";
import axiosInstance from "../api";
import { setLoyaltyConfig, setLoyaltyTransactions, setLoyaltyUserPoints } from "../../reusableSlice";

export const getLoyaltyConfig = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/loyalty/config");
    if (response?.data?.status) {
      dispatch(setLoyaltyConfig(response?.data?.response));
    } else {
      dispatch(setLoyaltyConfig(null));
    }
  } catch (err) {
    dispatch(setLoyaltyConfig(null));
  }
};

export const updateLoyaltyConfig = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/loyalty/config", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Loyalty configuration updated",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      dispatch(getLoyaltyConfig());
    } else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: "Something went wrong",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};

export const getLoyaltyTransactions = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/loyalty/transactions", {
      params: data,
    });
    if (response?.data?.status) {
      dispatch(setLoyaltyTransactions(response?.data?.response));
    } else {
      dispatch(setLoyaltyTransactions({ transactions: [], pagination_meta: null }));
    }
  } catch (err) {
    dispatch(setLoyaltyTransactions({ transactions: [], pagination_meta: null }));
  }
};

export const getLoyaltyUserPoints = (userId) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/loyalty/users/${userId}/points`);
    if (response?.data?.status) {
      dispatch(setLoyaltyUserPoints(response?.data?.response));
    } else {
      dispatch(setLoyaltyUserPoints(null));
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    dispatch(setLoyaltyUserPoints(null));
  }
};

